/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Spinner } from 'react-bootstrap';

import '../styles/Loading.css';

function Loading() {
	return (
		<div className="spinner">
			<Spinner animation="border" role="status">
				<span className="visually-hidden">Chargement...</span>
			</Spinner>
		</div>
	);
}

export default Loading;
